interface MenuItem {
  itemKey: string;
  name: string;
  url: string;
  isExternal?: boolean;
  items?: MenuItem[];
  // permissions can be added in here
}

const menu: MenuItem[] = [
  {
    itemKey: "consultationPage",
    name: "Consultations",
    url: "/consultations",
  },
  {
    itemKey: "lawyerPage",
    name: "Lawyers",
    url: "/lawyers",
  },
  {
    itemKey: "adCampaigns",
    name: "Ad campaigns",
    url: "/ad-campaigns",
  },
  {
    itemKey: "community",
    name: "Community",
    url: "/community/posts",
  },
  {
    itemKey: "rfePage",
    name: "RFE",
    url: "/rfe",
  },
  {
    itemKey: "newsPage",
    name: "News",
    url: "/news",
  },
  {
    itemKey: "chatPage",
    name: "Chat",
    url: "/chats",
  },
];

export default menu;
